import { Component } from '@angular/core';
import { FormGroup } from '@angular/forms';

import { Field } from '../../models/field.interface';
import { MatDialog } from '@angular/material/dialog';
import { GlobalUtils } from 'src/app/shared/global-utils';
import { TypeIndexEnum } from 'src/app/domain/registration/enums/type-index.enum';
import { TypeCesEnum } from 'src/app/domain/registration/enums/type-ces.enum';
import { IFieldConfig } from 'src/app/domain/IFieldConfig';

@Component({
  selector: 'form-select',
  styleUrls: ['form-select.component.sass'],
  template: `
    <div class="dynamic-field form-select" [formGroup]="group">
      <div class="title_box" id="bill_to">
        <div id="title">{{ config.label }}*</div>
        <div
          matRipple
          id="content"
          (click)="openSelectCrud()"
          [matRippleDisabled]="this.typeCes === typeCesEnum.SHOW"
        >
          <div
            [ngClass]="
              group.get(this.config.name)?.getRawValue()
                ? 'text-value'
                : 'text-value-placeholder'
            "
          >
            <input
              type="hidden"
              [formControlName]="config.name"
              [ngModel]="group.get(this.config.name)?.getRawValue()"
            />
            {{
              group.get(this.config.name)?.getRawValue()
                ? group.get(this.config.name)?.getRawValue()
                : placeholder
            }}
          </div>
          <mat-icon class="arrow-down" *ngIf="this.typeCes !== typeCesEnum.SHOW"
            >keyboard_arrow_down</mat-icon
          >
        </div>
      </div>
    </div>
  `,
})
export class FormSelectCrudComponent implements Field {
  config: IFieldConfig;
  group: FormGroup;
  typeCes?: TypeCesEnum | undefined;
  placeholder = 'Selecione uma opção';

  constructor(public dialog: MatDialog) { }

  openSelectCrud() {
    if (this.typeCes === TypeCesEnum.SHOW) return;

    GlobalUtils.openDialog({
      dialog: this.dialog,
      component: this.config.component,
      data: {
        type: TypeIndexEnum.SELECT,
        select: true,
        params: this.config.componentData?.params
      },
      callBack: (data: any) => {
        if (data) {
          this.group.get(this.config.name)?.setValue(data[this.config.value]);
        }
      },
    });
  }

  get typeCesEnum() {
    return TypeCesEnum;
  }
}
